import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useCovid19Store = defineStore({
    id: 'covid19',
    state: () => ({
        eggDescList: [
            {
                eggBackgroundObj: { componentName: 'covid19', imgName: 'fifthWave', imgFormat: 'png' },
                label: 'covid19.factsFirstDesc'
            },
            {
                eggBackgroundObj: { componentName: 'covid19', imgName: 'vaccination', imgFormat: 'png' },
                label: 'covid19.factsSecondDesc'
            },
            {
                eggBackgroundObj: { componentName: 'covid19', imgName: 'socialDistance', imgFormat: 'png' },
                label: 'covid19.factsThirdDesc'
            }
        ],
        generalInformationList: [
            {
                id: 'whatarecovid',
                title: 'covid19.whatAreCovidTitle',
                description: 'covid19.whatAreCovidDesc',
                isExpand: false
            },
            {
                id: 'howdescovidspread',
                title: 'covid19.howDesCovidSpreadTitle',
                description: 'covid19.howDesCovidSpreadDesc',
                isExpand: false
            },
            {
                id: 'symptomsofcovid',
                title: 'covid19.symptomsOfCovidTitle',
                description: 'covid19.symptomsOfCovidDesc',
                isExpand: false
            },
            {
                id: 'treatmentofcovid',
                title: 'covid19.treatmentOfCovidTitle',
                description: 'covid19.treatmentOfCovidDesc',
                isExpand: false
            },
            {
                id: 'comparedtosars',
                title: 'covid19.comparedToSarsTitle',
                description: 'covid19.comparedToSarsDesc',
                isExpand: false
            },
            {
                id: 'riseincovid',
                title: 'covid19.ristInCovidTitle',
                description: 'covid19.ristInCovidDesc',
                isExpand: false
            },
            {
                id: 'avoidanimal',
                title: 'covid19.avoidAnimalTitle',
                description: 'covid19.avoidAnimalDesc',
                isExpand: false
            },
            {
                id: 'latestinformation',
                title: 'covid19.latestInformationTitle',
                description: 'covid19.latestInformationDesc',
                isExpand: false
            },
        ],
        sideEffectList: [
            {
                id: 'injectoinsite',
                label: 'covid19.injectoinsite',
                col: 1
            },
            {
                id: 'feverCills',
                label: 'covid19.feverChills',
                col: 1
            },
            {
                id: 'headachePain',
                label: 'covid19.headachePain',
                col: 1
            },
            {
                id: 'tiredness',
                label: 'covid19.tiredness',
                col: 1
            },
            {
                id: 'lymphNode',
                label: 'covid19.lymphNode',
                col: 1
            },
        ],
        howToManageList: [
            {
                id: 'paracetamol',
                label: 'covid19.paracetamol',
                col: 3
            },
            {
                id: 'rest',
                label: 'covid19.rest',
                col: 1
            },
            {
                id: 'getsBetterItself',
                label: 'covid19.getsBetterItself',
                col: 1
            },
        ],
        seeADoctorList: [
            {
                id: 'sideEffectsGettingWorse',
                label: 'covid19.sideEffectsGettingWorse'
            },
            {
                id: 'feverPersists',
                label: 'covid19.feverPersists'
            },
            {
                id: 'respiratorySymptoms',
                label: 'covid19.respiratorySymptoms'
            },
            {
                id: 'heartChestSymptoms',
                label: 'covid19.heartChestSymptoms'
            },
        ],
        governmentVenueList: [
            {
                id: 'communityCentre',
                order: '1',
                label: 'covid19.cvc',
                description: 'covid19.cvcDesc',
                annotation: 'covid19.sameDayTickets'
            },
            {
                id: 'popupCentre',
                order: '1A',
                label: 'covid19.pcvc',
                description: 'covid19.pcvcDesc',
                annotation: 'covid19.sameDayTickets'

            },
            {
                id: 'childrenCentre',
                order: '2',
                label: 'covid19.ccvc',
                description: 'covid19.ccvcDesc'
            },
            {
                id: 'designedCentre',
                order: '3',
                label: 'covid19.gopcs',
                description: 'covid19.gopcsDesc'
            },
            {
                id: 'designatedClinics',
                order: '4',
                label: 'covid19.designatedClinics',
                description: 'covid19.designatedClinicsDesc'
            },
            {
                id: 'residentialHomes',
                order: '5',
                label: 'covid19.residentialHomes',
                description: 'covid19.residentialHomesDesc'
            },
            {
                id: 'designatedClinicsDH',
                order: '6',
                label: 'covid19.designatedClinicsDH',
                description: 'covid19.designatedClinicsDHDesc'
            },
            {
                id: 'hospitalStations',
                order: '7',
                label: 'covid19.hospitalStations',
                description: 'covid19.hospitalStationsDesc'
            },
            {
                id: 'mobileVaccination',
                order: '8',
                label: 'covid19.mobileVaccination',
                description: 'covid19.mobileVaccinationDesc'
            },
            {
                id: 'districtHealthCentre',
                order: '9',
                label: 'covid19.districtHealthCentre',
                description: 'covid19.districtHealthCentreDesc'
            },
            {
                id: 'outreachVacc',
                order: '10',
                label: 'covid19.outreachVacc',
                description: 'covid19.outreachVaccDesc'
            },
        ],
        selectedGovVenue: {},
        faqsList: [
            {
                id: 'sureMedicallySafe',
                title: 'covid19.sureMedicallySafeTitle',
                description: 'covid19.sureMedicallySafeDesc',
                isExpand: false
            },
            {
                id: 'needForBoosterDose',
                title: 'covid19.needForBoosterDoseTitle',
                description: 'covid19.needForBoosterDoseDesc',
                isExpand: false
            },
            {
                id: 'childShouldntVacc',
                title: 'covid19.childShouldntVaccTitle',
                description: 'covid19.childShouldntVaccDesc',
                isExpand: false
            },
            {
                id: 'vaccSafePregnant',
                title: 'covid19.vaccSafePregnantTitle',
                description: 'covid19.vaccSafePregnantDesc',
                isExpand: false
            },
            {
                id: 'protectStrain',
                title: 'covid19.protectStrainTitle',
                description: 'covid19.protectStrainDesc',
                isExpand: false
            },
            {
                id: 'overseaVaccRecord',
                title: 'covid19.overseaVaccRecordTitle',
                description: 'covid19.overseaVaccRecordDesc',
                isExpand: false
            },
        ],
        usefulArticlesList: [
            {
                id: 'onvaccEffect',
                label: 'covid19.onvaccEffect',
                itemList: [
                    {
                        label: 'covid19.mRNAStudy',
                        url: 'https://www.cdc.gov/media/releases/2021/p0607-mrna-reduce-risks.html'

                    },
                    {
                        label: 'covid19.effectBenefits',
                        url: 'https://www.canada.ca/en/public-health/services/diseases/coronavirus-disease-covid-19/vaccines/effectiveness-benefits-vaccination.html'
                    },
                    {
                        label: 'covid19.effectProt',
                        url: 'https://www.health.gov.au/initiatives-and-programs/covid-19-vaccines/approved-vaccines/how-they-work'
                    },
                    {
                        label: 'covid19.howWellWork',
                        url: 'https://www.nhs.uk/conditions/coronavirus-covid-19/coronavirus-vaccination/coronavirus-vaccine/',
                    },
                    {
                        label: 'covid19.howVaccWork',
                        url: 'https://www.who.int/news-room/feature-stories/detail/how-do-vaccines-work'

                    },
                    {
                        label: 'covid19.vaccDevelop',
                        url: 'https://www.who.int/news-room/feature-stories/detail/how-are-vaccines-developed'
                    },
                    {
                        label: 'covid19.manufa',
                        url: 'https://www.who.int/news-room/feature-stories/detail/manufacturing-safety-and-quality-control'
                    },
                    {
                        label: 'covid19.howDeathRates',
                        url: 'https://ourworldindata.org/covid-deaths-by-vaccination',
                    }
                ]
            },
            {
                id: 'boosterDoses',
                label: 'covid19.boosterDoses',
                itemList: [
                    { label: 'covid19.boosterProection', url: 'https://www.gov.uk/government/news/boosters-give-over-90-protection-against-symptomatic-covid-19-in-adults-over-50' },
                    { label: 'covid19.CDCState', url: 'https://www.cdc.gov/media/releases/2021/p0924-booster-recommendations-.html' },
                    { label: 'covid19.boosterAdvice', url: 'https://www.health.gov.au/initiatives-and-programs/covid-19-vaccines/getting-your-vaccination/booster-doses' },
                    { label: 'covid19.vaccBoosters', url: 'https://www.health.govt.nz/our-work/diseases-and-conditions/covid-19-novel-coronavirus/covid-19-vaccines/covid-19-vaccine-boosters' },
                    { label: 'covid19.candaAuth', url: 'https://www.canada.ca/en/health-canada/news/2021/11/health-canada-authorizes-the-use-of-the-pfizer-biontech-comirnaty-covid-19-vaccine-as-a-booster-shot.html' },
                    { label: 'covid19.manueffect3rd', url: 'https://www.cdc.gov/mmwr/volumes/71/wr/mm7104e3.htm?s_cid=mm7104e3_x' }
                ]
            },
            {
                id: 'vaccChildren',
                label: 'covid19.vaccChildren',
                itemList: [
                    { label: 'covid19.recommPediatric', url: 'https://www.cdc.gov/media/releases/2021/s1102-PediatricCOVID-19Vaccine.html' },
                    { label: 'covid19.parentNeedToKnow', url: 'https://www.hopkinsmedicine.org/health/conditions-and-diseases/coronavirus/covid19-vaccine-what-parents-need-to-know' },
                    { label: 'covid19.vaccYourKids', url: 'https://unchartedterritories.tomaspueyo.com/p/should-you-vaccinate-your-child' },
                    { label: 'covid19.vaccChildrenCovid', url: 'https://www.canada.ca/en/public-health/services/vaccination-children/covid-19.html' }
                ]
            },
            {
                id: 'vaccForPregnant',
                label: 'covid19.vaccForPregnant',
                itemList: [
                    { label: 'covid19.guidePreg', url: 'https://www.gov.uk/government/publications/covid-19-vaccination-women-of-childbearing-age-currently-pregnant-planning-a-pregnancy-or-breastfeeding/covid-19-vaccination-a-guide-for-women-of-childbearing-age-pregnant-planning-a-pregnancy-or-breastfeeding' },
                    { label: 'covid19.pregnaNBreastFeeding1', url: 'https://www.health.gov.au/resources/publications/pregnancy-breastfeeding-and-covid-19-vaccines-english' },
                    { label: 'covid19.pregnaNBreastFeeding2', url: 'https://www.health.govt.nz/our-work/diseases-and-conditions/covid-19-novel-coronavirus/covid-19-vaccines/covid-19-vaccine-health-advice/covid-19-vaccine-pregnancy-and-breastfeeding' },
                    { label: 'covid19.vaccWhilePregnant', url: 'https://www.cdc.gov/coronavirus/2019-ncov/vaccines/recommendations/pregnancy.html' },
                    { label: 'covid19.vaccNPreg', url: 'https://www.canada.ca/en/public-health/services/immunization-vaccines/vaccination-pregnancy-covid-19.html' }
                ]
            },
            {
                id: 'falsehoods',
                label: 'covid19.falsehoods',
                itemList: [
                    { label: 'covid19.factsVacc', url: 'https://covid19.govt.nz/covid-19-vaccines/get-the-facts-about-covid-19-vaccination/' },
                    { label: 'covid19.trueFActs', url: 'https://www.health.gov.au/initiatives-and-programs/covid-19-vaccines/is-it-true' },
                    { label: 'covid19.mythNFacts', url: 'https://www.cdc.gov/coronavirus/2019-ncov/vaccines/facts.html' },
                    { label: 'covid19.mythbusters', url: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public/myth-busters#misinformation' }
                ]
            },
        ]
    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useCovid19Store, import.meta.hot));
}

export { useCovid19Store };
